<script lang="ts">
	import Loading from '#lib/svg/loading.svg.svelte';
	import { cubicIn, cubicOut } from 'svelte/easing';
	import { fly } from 'svelte/transition';
	import { widgetCurrentStep, type WidgetStepType } from '#lib/widget/booking/flow.js';
	import WidgetFooter from './WidgetFooter.svelte';
	import WidgetRestartButton from './WidgetRestartButton.svelte';
	import WidgetTitle from './WidgetTitle.svelte';
	import { onMount, untrack } from 'svelte';

	interface Props {
		title?: string;
		widgetStep?: WidgetStepType | undefined;
		hideRestartButton?: boolean;
		loaded?: boolean;
		children?: import('svelte').Snippet;
	}

	let {
		title = '',
		widgetStep = undefined,
		hideRestartButton = false,
		loaded = true,
		children
	}: Props = $props();

	let mounted = $state(false);

	onMount(() => {
		mounted = true;
	});

	$effect(() => {
		if (widgetStep && untrack(() => $widgetCurrentStep) !== widgetStep) {
			$widgetCurrentStep = widgetStep;
		}
	});
</script>

<div class="w-full h-fit flex flex-col items-center">
	{#if loaded && mounted}
		<div
			class="w-full"
			in:fly={{ easing: cubicOut, y: 10, duration: 300, delay: 300 }}
			out:fly={{ easing: cubicIn, y: -10, duration: 300 }}
		>
			{#if title}
				<WidgetTitle>{title}</WidgetTitle>
			{/if}
			{@render children?.()}
			{#if !hideRestartButton}
				<WidgetRestartButton />
			{/if}
			<WidgetFooter />
		</div>
	{:else}
		<div class="w-full flex justify-center py-8">
			<Loading className="w-8 h-8 mx-auto" width="w-12" />
		</div>
	{/if}
</div>
